import {ProductList} from "../../../typescript-library";
import {updateProductListRequestParams} from "./helpers/updateProductListRequestParams";
import {ProductListState} from "./ProductListProvider";
import {ProductListAction} from "./actions";

// eslint-disable-next-line complexity
export const reducer = (state: ProductListState, action: ProductListAction): ProductListState => {
  const stateOverwrite = {
    ...state,
  };
  switch (action?.type) {
    case "VIEW_MORE":
      // Set new offset and reset limit
      stateOverwrite.offset = state.offset + state.limit;
      stateOverwrite.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
      updateProductListRequestParams(stateOverwrite);
      break;
    case "RESET":
      stateOverwrite.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
      stateOverwrite.offset = 0;
      stateOverwrite.filters = {};
      updateProductListRequestParams(stateOverwrite);
      break;
    case "SET_LOADING":
      stateOverwrite.loading = action.payload;
      break;
    case "SHOW_FILTERS":
      stateOverwrite.showFilters = action.payload;
      break;
    case "SET_FILTER":
      // Reset offset and limit
      stateOverwrite.offset = 0;
      stateOverwrite.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
      stateOverwrite.filters = {
        ...state.filters,
        [action.payload.field]: action.payload.value,
      };
      updateProductListRequestParams(stateOverwrite);
      break;
    case "SET_FILTERS":
      stateOverwrite.filters = action.payload.filters;
      if (action.payload.doUrlParamUpdate) {
        updateProductListRequestParams(stateOverwrite);
      }
      break;
    case "REMOVE_FILTER":
      // Reset offset and limit
      stateOverwrite.offset = 0;
      stateOverwrite.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
      const newFilters = Object.assign({}, state.filters);
      delete newFilters[action.payload.field];
      stateOverwrite.filters = newFilters;
      updateProductListRequestParams(stateOverwrite, action.payload.field);
      break;
    case "SET_ITEMS":
      stateOverwrite.items = [...action.payload.items];
      stateOverwrite.total = action.payload.total;
      stateOverwrite.isLastPage = stateOverwrite.items.length >= stateOverwrite.total;
      break;
    case "SET_SORT":
      // Reset offset and limit
      stateOverwrite.orderBy = action.payload.orderBy;
      stateOverwrite.order = action.payload.order;
      if (action.payload.doUrlParamUpdate) {
        stateOverwrite.offset = 0;
        stateOverwrite.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
        updateProductListRequestParams(stateOverwrite);
      }
      break;
    case "SET_LIMIT":
      stateOverwrite.limit = action.payload;
      stateOverwrite.offset = 0;
      break;
    case "TRIGGER":
      stateOverwrite.trigger = !state.trigger;
      break;
    case "SET_IS_LAST_PAGE_BY_PRELOAD":
      stateOverwrite.isLastPage = true;
      break;
    case "SET_RANGE_FILTERS_VALUES":
      stateOverwrite.rangeFilterMap?.set(action.payload.field, action.payload.value);
      break;
  }

  return stateOverwrite;
};
